import { useState } from "react"
import { Actions, ActionProps, Reducer } from "./reducer"
import { State } from "./State"

const useAsyncReducer = (reducer: Reducer, initialState: State) => {
  const [state, setState] = useState<State>(initialState)

  const dispatch = async (action: ActionProps) => {
    const result = reducer(state, action)

    try {
      const newState = await result
      if (newState) setState(newState)
    } catch (err) {
      console.error(err)
    }
  }

  return [state, dispatch] as const
}

export default useAsyncReducer
